import React from 'react';
import { UserProfile } from '../../types';
import { AppSettings } from '../../lib/storage';
import { Palette, Globe, Save } from 'lucide-react';
import { soundEffects } from '../../lib/soundEffects';

interface Props {
  currentUser: UserProfile;
  appSettings: AppSettings;
  onUpdateSettings: (settings: Partial<AppSettings>) => void;
}

export const LanguageAppearanceSection: React.FC<Props> = ({ currentUser, appSettings, onUpdateSettings }) => {
  const handleSave = () => {
    soundEffects.playTap();
  };

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="bg-[#0e1422] rounded-3xl p-5 border border-slate-800/80 shadow-lg">
        <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
          <Globe className="w-5 h-5 text-teal-400" />
          اللغة (Language)
        </h3>

        <div className="space-y-2">
          {['ar', 'en', 'tr'].map((lang) => (
            <button
              key={lang}
              onClick={() => {
                // In a real app with i18n, we would set the locale here.
                onUpdateSettings({ language: lang as any });
              }}
              className={`w-full flex items-center justify-between p-3 rounded-xl border transition ${appSettings.language === lang ? 'bg-teal-500/20 border-teal-500/50 text-teal-400' : 'bg-[#141c2a] border-slate-800 text-slate-300 hover:border-slate-600'}`}
            >
              <span className="font-semibold">{lang === 'ar' ? 'العربية (Arabic)' : lang === 'en' ? 'English (الإنجليزية)' : 'Türkçe (التركية)'}</span>
              {appSettings.language === lang && <div className="w-2 h-2 rounded-full bg-teal-400 shadow-[0_0_8px_rgba(45,212,191,0.8)]" />}
            </button>
          ))}
          <div className="text-[10px] text-slate-400 mt-2 p-2">
            ملاحظة: تدعم منصة وتين تنسيق الكتابة من اليمين إلى اليسار (RTL) للغة العربية بشكل كامل وأصلي.
          </div>
        </div>
      </div>

      <div className="bg-[#0e1422] rounded-3xl p-5 border border-slate-800/80 shadow-lg">
        <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
          <Palette className="w-5 h-5 text-teal-400" />
          المظهر العام
        </h3>
        
        <div className="grid grid-cols-2 gap-3">
          {[
            { id: 'dark', label: 'الوضع الداكن (Dark)', bg: 'bg-[#060911]' },
            { id: 'light', label: 'الوضع الفاتح (Light)', bg: 'bg-white' },
            { id: 'midnight_diamond', label: 'ماسة منتصف الليل', bg: 'bg-gradient-to-br from-[#060911] to-[#121c2e]' },
          ].map((theme) => (
            <button
              key={theme.id}
              onClick={() => {
                soundEffects.playTap();
                onUpdateSettings({ theme: theme.id as any });
              }}
              className={`relative overflow-hidden rounded-xl border-2 transition ${appSettings.theme === theme.id ? 'border-teal-400' : 'border-slate-800 hover:border-slate-600'}`}
            >
              <div className={`h-16 ${theme.bg}`}></div>
              <div className="p-2 bg-[#141c2a] text-xs font-bold text-center text-white">{theme.label}</div>
              {appSettings.theme === theme.id && (
                <div className="absolute top-2 left-2 bg-teal-500 text-[#060911] p-1 rounded-full shadow-lg">
                  <Save className="w-3 h-3" />
                </div>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
